import axios from "axios";

/**
 * 桌布活動「數據 log system」專用的 axios instance。
 *
 * 與會員中心的 apiAnalytics（REACT_APP_ANALYTICS_API_URL / toryburch-analytics）不同，
 * 這裡打的是 REACT_APP_ANALYTICS_LOG_SYSTEM_API_URL（imag-analytics），
 * 並用獨立的 log_token，避免與會員中心的 DATA_TOKEN 互相覆蓋。
 */
function apiLogSystem() {
	const API_URL = process.env.REACT_APP_ANALYTICS_LOG_SYSTEM_API_URL;
	const instance = axios.create({
		baseURL: API_URL,
		// 數據請求不設 timeout 的話，網路卡住時會無限等待，
		// 連帶把等它的流程（例如登入 Guard）一起卡住
		timeout: 10000,
	});

	const setupInterceptors = () => {
		// 請求攔截器：帶上 log_token
		instance.interceptors.request.use(
			(config) => {
				const token = localStorage.getItem("log_token");
				if (token) {
					config.headers["Authorization"] = `Bearer ${token}`;
				}
				return config;
			},
			(error) => Promise.reject(error),
		);

		// 回應攔截器：直接回傳 res.data
		instance.interceptors.response.use(
			(res) => res.data,
			(error) => Promise.reject(error),
		);
	};

	setupInterceptors();

	return instance;
}

export default apiLogSystem();
